import React, { useState, useMemo } from 'react';
import Item from './Item';

const CompanyItem = ({ 
  className, 
  companyLevel = "default", 
  companies: propCompanies, 
  loadingCompanies: propLoadingCompanies, 
  errorCompanies: propErrorCompanies, 
  selectedRegion = 'All', 
  selectedIndustry = '全部',
  currentPage,
}) => {
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const companies = propCompanies || [];
  const loadingCompanies = propLoadingCompanies || false;
  const errorCompanies = propErrorCompanies || null;

  // 根据目前行业和地区确定展示公司的等级
  const getPriorityLevels = (selectedRegion, selectedIndustry) => {
    if (companyLevel !== 'default') {
      return ['LandingCompany'];
    }
    if (selectedRegion === 'All' && selectedIndustry === '全部') {
      return ['LandingBanner', 'LandingCompany', 'BigAd', 'SmallAd', 'IndustAll', 'AllLocal', 'IndustLocal', 'Default'];
    } else if (selectedRegion === 'All' && selectedIndustry !== '全部') {
      return ['LandingCompany', 'IndustAll', 'BigAd', 'SmallAd', 'Default'];
    } else if (selectedRegion !== 'All' && selectedIndustry === '全部') {
      return ['SmallAd', 'AllLocal', 'BigAd', 'SmallAd', 'Default'];
    } else if (selectedRegion !== 'All' && selectedIndustry !== '全部') {
      return ['IndustLocal', 'BigAd', 'SmallAd', 'Default'];
    } else {
      return ['Default'];
    }
  };

  const filteredCompanies = useMemo(() => {
    const companyList = companies || [];
    const levels = getPriorityLevels(selectedRegion, selectedIndustry);
  
    // const companiesWithLevels = companyList.filter((company) =>
    //   company.company_level.some((level) => {
    //     return levels.some((priorityLevel) => level.toLowerCase().includes(priorityLevel.toLowerCase()));
    //   })
    // );

    const companiesWithLevels = companyList.filter((company) => {
      // 确保 company.company_level 是数组
      const levelsArray = Array.isArray(company.company_level) ? company.company_level : [];
      return levelsArray.some((level) => {
        return levels.some((priorityLevel) => level.toLowerCase().includes(priorityLevel.toLowerCase()));
      });
    });

    const sortedCompanies = companiesWithLevels.sort((a, b) => {
      const aLevelIndex = levels.findIndex((priorityLevel) =>
        a.company_level.some((level) => level.toLowerCase() === priorityLevel.toLowerCase())
      );
      const bLevelIndex = levels.findIndex((priorityLevel) =>
        b.company_level.some((level) => level.toLowerCase() === priorityLevel.toLowerCase())
      );
      return aLevelIndex - bLevelIndex;
    });
  
    return sortedCompanies;
  }, [companies, selectedRegion, selectedIndustry, companyLevel]);  

  const companiesPerPage = 12; // 每页12家公司
  const startIndex = (currentPage - 1) * companiesPerPage;
  const endIndex = startIndex + companiesPerPage;

  const paginatedCompanies = filteredCompanies.slice(startIndex, endIndex); 

  return (
    <div className={`flex flex-wrap mb-3 mt-3 container mx-auto px-2 md:px-4 justify-center sm:justify-start -mx-2 ${className}`}>
    {loadingCompanies ? (
      <p>Loading...</p>
    ) : errorCompanies ? (
      <p>Error loading companies. Please try again later.</p>
    ) : (
      Array.isArray(paginatedCompanies) && paginatedCompanies.map((exp, index) => (
        <div key={exp.id || index} className="w-1/2 sm:w-1/3 md:w-1/3 lg:w-1/4 xl:w-1/4 py-2 px-2 md:px-4">
          <Item
            company={exp}
            onHover={setHoveredItemId}
            isHovered={hoveredItemId === exp.id}
          />
          <div className="flex items-center justify-center gap-2 py-2 mt-2">
            <p className={`text-center text-xs sm:text-sm md:text-sm lg:text-base xl:text-md ${className}`}>{exp.name}</p>
          </div>
        </div>
      ))
    )}
  </div>
  );
};

export default CompanyItem;
